import hours from './hours';

const root = {
	hours
};

export default root;
